import { NgModule } from "@angular/core";
import { DocumentScannerFormComponent } from './document-scanner-form/document-scanner-form.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { DynamicDocumentScannerComponent } from './dynamic-document-scanner.component';
import { DocumentScannerDesignComponent } from './document-scanner-design/document-scanner-design.component';
import { DocumentScannerResultComponent } from './document-scanner-result/document-scanner-result.component';

@NgModule({
    declarations: [
        DocumentScannerResultComponent,
        DocumentScannerDesignComponent,
        DocumentScannerFormComponent, 
        DynamicDocumentScannerComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule
    ],
    exports: [
        DocumentScannerFormComponent
    ],
    entryComponents: [
        DynamicDocumentScannerComponent
    ]
})
export class DocumentScannerModule {}